import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  Col,
  Typography,
  Space,
  Button,
  Steps,
  Avatar,
  Spin,
} from "antd";
import Headings from "../../atoms/Headigs";
import {
  AdditionalDetalsIcon,
  DesignSvgIcon,
  DevelopmentIcon,
  GoLiveIcon,
  PaymentIcon,
  UatIcon,
} from "../../atoms/CustomIcons";
import { CheckCircleFilled, CloseOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Lottie from "lottie-react";
import developer from "../../../assets/lottie/developer.json";
import Dashboard from "../../templates/Dashboard";

const DevelopmentScreen = (props) => {
  const { Paragraph, Text } = Typography;
  return (
    <Col span={24}>
      <Headings
        title="Development"
        titleSize={2}
        description={`Your app is under development`}
        space={5}
      />
      <Col span={24} style={{ justifyContent: "center", display: "flex" }}>
        <Lottie
          animationData={developer}
          loop={true}
          style={{ width: "60%", height: "60%" }}
        />
      </Col>
      <Paragraph className="c-gray center-align-text px-2 fontSize16Medium ">
        Your will be notified as soon as your app is ready for UAT. Please
        reachout to our support
        <Text className="text-base defaultFont"> support@purewl.com</Text> for
        any concern or query.
      </Paragraph>
    </Col>
  );
};
export default DevelopmentScreen;
